import { chatPublicShareQueryKey } from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

export interface IUseChatPublicShareParams {
  chatUuid: string;
  enabled: boolean;
}

// NOTE: The owner's view of their chat's public link, including the recoverable
// password so the dialog can reveal it instead of forcing a regeneration.
// Resolves to `null` when the chat has no live link — an expected state, not an
// error, so nothing is toasted.
export const useChatPublicShare = ({
  chatUuid,
  enabled,
}: IUseChatPublicShareParams) => {
  return useQuery({
    queryKey: chatPublicShareQueryKey(chatUuid),
    queryFn: () => chatApi.getChatPublicShare(chatUuid),
    enabled: enabled && Boolean(chatUuid),
  });
};
